import PieChart from "./PieChart";
import type { PieChartProps } from "./PieChart.d";

export default PieChart;
export type { PieChartProps };
